/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentHistoricalResult } from './DocumentHistoricalResult';
import {
    DocumentHistoricalResultFromJSON,
    DocumentHistoricalResultFromJSONTyped,
    DocumentHistoricalResultToJSON,
} from './DocumentHistoricalResult';

/**
 * 
 * @export
 * @interface DocumentsHistoricalResult
 */
export interface DocumentsHistoricalResult {
    /**
     * 
     * @type {string}
     * @memberof DocumentsHistoricalResult
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentsHistoricalResult
     */
    date?: number;
    /**
     * 
     * @type {Array<DocumentHistoricalResult>}
     * @memberof DocumentsHistoricalResult
     */
    results?: Array<DocumentHistoricalResult>;
}

/**
 * Check if a given object implements the DocumentsHistoricalResult interface.
 */
export function instanceOfDocumentsHistoricalResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentsHistoricalResultFromJSON(json: any): DocumentsHistoricalResult {
    return DocumentsHistoricalResultFromJSONTyped(json, false);
}

export function DocumentsHistoricalResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentsHistoricalResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(DocumentHistoricalResultFromJSON)),
    };
}

export function DocumentsHistoricalResultToJSON(value?: DocumentsHistoricalResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': value.date,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(DocumentHistoricalResultToJSON)),
    };
}

